'use client';
import classNames from 'classnames';

import { CartListTotal } from '@/entities/cart';
import {
  DELIVERY_DESCRIPTION,
  MIN_COST_DELIVERY_FREE,
} from '@/entities/delivery';
import { CartSyncStatus, useCartStore } from '@/features/cart';
import { CheckoutButton } from '@/features/checkout';
import { PromoInput } from '@/features/promo';
import { formatPrice } from '@/shared/lib';
import { CartEmpty, CartList } from '@/widgets/cart/ui';

import styles from './cartPage.module.scss';

const CartPage = () => {
  const { items, totalCount, totalPrice, priceDetails } = useCartStore();

  function renderCurrentDeliveryTest() {
    if (totalPrice < MIN_COST_DELIVERY_FREE) {
      return `Еще ${formatPrice(MIN_COST_DELIVERY_FREE - totalPrice)} ${DELIVERY_DESCRIPTION.less}`;
    }

    return DELIVERY_DESCRIPTION.free;
  }

  function renderCartItems() {
    return (
      <div className={styles.cartPage__content}>
        <div className={styles.cartPage__title_block}>
          <p className={styles.cartPage__title}>Корзина</p>
        </div>
        <CartList className={styles.cartPage__cart_list} items={items} />
        <div className={styles.cartPage__total_row}>
          <p className={styles.cartPage__total_text}>
            {renderCurrentDeliveryTest()}
          </p>
          <CartListTotal
            className={styles.cartPage__total_block}
            discounts={priceDetails}
            price={totalPrice}
            quantity={totalCount}
          />
        </div>
        <CartSyncStatus />
        <div className={styles.cartPage__btn_row}>
          <PromoInput className={styles.cartPage__promo_btn} />
          <CheckoutButton />
        </div>
      </div>
    );
  }

  return (
    <main className={classNames(styles.cartPage, 'page')}>
      <div className={classNames('container', styles.cartPage__wrapper)}>
        {items.length > 0 ? (
          renderCartItems()
        ) : (
          <>
            <CartSyncStatus />
            <CartEmpty />
          </>
        )}
      </div>
    </main>
  );
};

export default CartPage;
